export const enrollPasskeyBodyStyles = { display: 'flex', flexDirection: 'column', gap: 12 };

export const enrollPasskeyErrorStyles = { marginTop: 4 };
